module.exports = __webpack_public_path__ + "bg.1e5de095a72f5fa4f615.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/bg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/bg.svg
// module chunks = styles